import Light from '../views/components/ThemeSelector/Light.png';

export const LANGUAGE_MAPS = {
    'VN': 'vi',
    'US': 'en',
};

export const LANGUAGE_CACHE_KEY = 'akadoc:language';

export const THEMES = {
    Light: 'Default',
    // Dark: 'Dark',
    // Green: 'Green',
};

export const THEME_IMAGES = {
    // 'Dark': Dark,
    'Light': Light,
    // 'Green': Green,
}

export const THEME_CACHE_KEY = 'akadoc:theme';
